import { toast } from 'react-toastify';
import { FINANZAS_API } from "../../views/MainLayout/components/shared/services/finanzas";
import { setErrorMessage } from '../../views/MainLayout/components/shared/helpers/functionalities';

const initialState = {
    comprobantes_crm: [],
    pedidos_crm: [],
    comprobantes_vo: [],
    pedidos_vo: []
}

export const finanzasReducer = (state = initialState, action) => {
    switch(action.type){
        case "finanzas/fullfilled": {
            return action.payload;
        }
        case "finanzas/comprobantes": {
            return {...state, comprobantes_crm: action.payload }
        }
        case "finanzas/comprobantes_vo": {
            return {...state, comprobantes_vo: action.payload }
        }
        case "finanzas/pedidos": {
            return {...state, pedidos_crm: action.payload }
        }
        case "finanzas/pedidos_vo": {
            return {...state, pedidos_vo: action.payload }
        }
        default:
            return state
    }
}

export const fetchFinanzas = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })
    try {
        const response = await FINANZAS_API.get()
        const data = await response.data;
        dispatch({ type: 'finanzas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const fetchTransferenciasPorAprobar = (type) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })
    try {
        const response = await FINANZAS_API.getTransfersToApprove(type)
        const data = await response.data;
        dispatch({type: type === 'crm' ? "finanzas/comprobantes" : "finanzas/comprobantes_vo", payload: data}); 
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}

export const fetchPedidosPendientes = (type) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })
    try {
        const response = await FINANZAS_API.getPendingOrders(type)
        const data = await response.data;
        dispatch({type: type === 'crm' ? "finanzas/pedidos" : "finanzas/pedidos_vo", payload: data}); 
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}
